import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/pinia'
import loading from '@/assets/images/loading.png'
import lazyPlugin from 'vue3-lazy'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import mitt from 'mitt'
import locale from 'element-plus/lib/locale/lang/zh-cn'
const app = createApp(App)
app.config.globalProperties.Bus = mitt()
app.use(lazyPlugin, {
    loading: loading,
    error:loading
})
router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    next()
})
app.use(ElementPlus, { locale });
app.use(store).use(router).mount('#app')
